import { SubSink } from 'subsink';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { imageSwiperConfig } from '../../../../models';
import { NotifyAlertService } from '@monorepo/ui';
import { AuthService } from '@monorepo/ui/auth';
import {
  FavouriteScreens,
  FavouriteScreenItem,
  ScreenListing,
  SharedService,
} from '../../../shared';
@Component({
  selector: 'signgaze-listing-item',
  templateUrl: './listing-item.component.html',
  styleUrls: ['./listing-item.component.scss'],
})
export class ListingItemComponent implements OnInit, OnDestroy {
  readonly imageSwiperconfig = imageSwiperConfig;
  readonly subs = new SubSink();
  favouriteList: FavouriteScreenItem[] = [];
  isFavourite = false;
  @Input() isTrendingswiperActive;
  @Input() screenListing: ScreenListing;
  isListingAddedToBooking = false;

  constructor(
    private sharedService: SharedService,
    private notifyAlertService: NotifyAlertService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getFavList();
    this.checkListingBookingStatus();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public addLisitingToCurrentBooking(): void {
    this.isListingAddedToBooking = true;
    this.sharedService.addScreenToBooking(
      this.screenListing,
      this.screenListing.ownerId
    );
  }

  public removeScreenFromBooking(): void {
    this.isListingAddedToBooking = false;
    this.sharedService.removeScreenFromBooking(this.screenListing);
  }

  private checkListingBookingStatus(): void {
    this.subs.sink = this.sharedService
      .getCurrentBookedScreens()
      .pipe(
        map((screenListings: ScreenListing[]): string[] => {
          return screenListings.map(
            (screenListing: ScreenListing): string => screenListing.firestickId
          );
        })
      )
      .subscribe({
        next: (bookedFireStickIds: string[]): void => {
          this.isListingScreensPresentinBooking(bookedFireStickIds);
        },
      });
  }

  private isListingScreensPresentinBooking(bookedFireStickIds: string[]): void {
    if (bookedFireStickIds.includes(this.screenListing?.firestickId)) {
      this.isListingAddedToBooking = true;
    } else {
      this.isListingAddedToBooking = false;
    }
  }

  public showFavPopup(screen: ScreenListing): void {
    if (!this.authService.isUserLoggedIn.value) {
      this.router.navigate(['login']);
      return;
    }
    if (this.findScreenId(screen.id)) {
      const favouriteItem = this.findScreenId(screen.id);
      this.sharedService
        .removeItemFromFavouriteList(
          favouriteItem.favouriteListId,
          favouriteItem
        )
        .subscribe((): void => {
          this.notifyAlertService.success(`succesfully removed`);
        });
    } else {
      const size = 'Tiny';
      const title = 'Save to a list';
      this.sharedService.openFavouritesModal(title, screen, size);
    }
  }

  public getFavList(): void {
    this.sharedService.getFavouriteList().subscribe({
      next: (favourite: FavouriteScreens[]): void => {
        const data = favourite.map((item) => item.screens);
        this.favouriteList = [].concat(...data);
        this.isFavourite = this.isScreenExists(this.screenListing?.id);
      },
    });
  }

  public isScreenExists(screenId: string): boolean {
    return this.findScreenId(screenId) ? true : false;
  }

  public findScreenId(screenId: string): FavouriteScreenItem {
    if (this.favouriteList.length) {
      return this.favouriteList.find(
        (screen: FavouriteScreenItem) => screen?.screenId === screenId
      );
    }
  }
}
